"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelResultsChangeSalesforceCredsInfoTextStyle = exports.ModelEvaluationListStyle = exports.ModelCoefficientsEmptyChildStyle = exports.ModelCoefficientsDownloadButton = exports.ModelCoefficientsMetadata = exports.PredictionDetailTopFactorStyle = exports.PredictionDetailValueStyle = exports.PredictionDetailHeaderStyle = exports.PredictionDetailMetadataStyle = exports.PredictionDetailContainerStyle = exports.DataGridHeaderTextSortable = exports.DataGridHeaderText = exports.DataGridHeader = exports.DataGridPredictedValueFailure = exports.DataGridPredictedValueSuccess = exports.DataGridContainer = exports.BinomialKeyMetricsFirstRow = exports.BinomialPerformanceMetricsRowCell = exports.BinomialPerformanceMetricsRow = exports.RegressionPerformanceMetricsRow = exports.OverviewDataDistribution = exports.OverviewScoreChart = exports.OverviewScoreDescription = exports.OverviewScore = exports.OverviewScoreContainer = exports.OverviewContainer = exports.RocChartSummary = exports.ChartContainer = exports.ThresholdSummaryDescription = exports.ThresholdSummary = exports.ConfusionMatrixAsBarsProgressBars = exports.ConfusionMatrixAsBarsHeader = exports.ConfusionMatrixAsBarsContainer = exports.ConfusionMatrixContainer = exports.ThresholdCostRatioTextBox = exports.ThresholdCostRatioInfoPopover = exports.ThresholdCostRatioHeader = exports.ThresholdActionButton = exports.ThresholdActionSection = exports.ThresholdSliderHeader = exports.ThresholdDescription = exports.ThresholdControllerContainer = exports.ThresholdOptimizationHeader = exports.SummaryHighlightNumber = exports.SummaryContent = exports.SummaryHeader = exports.SummaryContainer = exports.metricsProgressBarErr = exports.metricsProgressBar = void 0;
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var StyleHelper_1 = require("./StyleHelper");
require("@tableau/fonts-tableau");
var modelResultSpacePrefix = 'ModelResult';
var getModelResultClassName = function (name) {
    return "".concat(modelResultSpacePrefix, "_").concat(name);
};
// TODO: move this to centralized place
var tableauLinkHover = '#2a79af';
var dataGridHeaderBg = '#F3F3F3';
exports.metricsProgressBar = '#70a8bd';
exports.metricsProgressBarErr = '#A1373E';
// Summary styles
exports.SummaryContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('summaryContainer'), {
    margin: '16px',
    padding: '32px 16px',
    height: '218px',
    background: prediction_model_results_viz_1.VizColors.white,
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '1500px',
});
exports.SummaryHeader = (0, StyleHelper_1.cssClass)(getModelResultClassName('summaryHeader'), {
    width: '727px',
    height: '36px',
    marginLeft: '20px',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '36px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
});
exports.SummaryContent = (0, StyleHelper_1.cssClass)(getModelResultClassName('summaryContent'), {
    width: '727px',
    margin: '12px 0 0 20px',
    fontWeight: 350,
    fontSize: '22px',
    lineHeight: '34px',
    letterSpacing: '0.2px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
});
exports.SummaryHighlightNumber = (0, StyleHelper_1.cssClass)(getModelResultClassName('summaryHighlightNumber'), {
    fontWeight: 400,
});
exports.ThresholdOptimizationHeader = (0, StyleHelper_1.cssClass)('thresholdOptimizationHeader', {
    fontWeight: 350,
    fontSize: '12px',
    lineHeight: '12px',
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    color: prediction_model_results_viz_1.VizColors.tableauGray12,
    margin: '5px 0',
});
// Threshold controller
exports.ThresholdControllerContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdControllerContainer'), {
    padding: '12px',
});
exports.ThresholdDescription = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdOptimizationDescription'), {
    fontWeight: 350,
    fontSize: '9px',
    lineHeight: '10px',
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    margin: '5px 0',
});
exports.ThresholdSliderHeader = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdSliderHeader'), {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '17px',
});
exports.ThresholdActionSection = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdActionSection'), {
    display: 'flex',
    justifyContent: 'space-between',
});
exports.ThresholdActionButton = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdActionSection'), {
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '10px',
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    color: prediction_model_results_viz_1.VizColors.textLinkDefault,
    cursor: 'pointer',
    $nest: {
        '&:hover': {
            textDecoration: 'underline',
            color: tableauLinkHover,
        },
    },
});
exports.ThresholdCostRatioHeader = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdCostRatioHeader'), {
    fontWeight: 350,
    fontSize: '12px',
    lineHeight: '12px',
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    marginTop: '17px',
    display: 'flex',
});
exports.ThresholdCostRatioInfoPopover = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdCostRatioInfoPopover'), {
    marginLeft: '5px',
    cursor: 'pointer',
});
exports.ThresholdCostRatioTextBox = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdCostRatioTextBox'), {
    marginTop: '5px',
    width: '100%',
});
// Confusion matrix
exports.ConfusionMatrixContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('confusionMatrixContainer'), {
    padding: '12px',
});
exports.ConfusionMatrixAsBarsContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('confusionMatrixAsBarsContainer'), {
    borderTop: '1px solid ' + prediction_model_results_viz_1.VizColors.tableauGray06,
    padding: '12px',
});
exports.ConfusionMatrixAsBarsHeader = (0, StyleHelper_1.cssClass)(getModelResultClassName('confusionMatrixAsBarsHeader'), {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 350,
    letterSpacing: '0.2px',
    lineHeight: '27px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
});
exports.ConfusionMatrixAsBarsProgressBars = (0, StyleHelper_1.cssClass)(getModelResultClassName('confusionMatrixAsBarsProgressBars'), {
    margin: '16px 0',
});
exports.ThresholdSummary = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdSummary'), {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 350,
    letterSpacing: '0.2px',
    lineHeight: '27px',
    color: prediction_model_results_viz_1.VizColors.black,
    textAlign: 'center',
    padding: '0 13%',
});
exports.ThresholdSummaryDescription = (0, StyleHelper_1.cssClass)(getModelResultClassName('thresholdSummaryDescription'), {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 350,
    letterSpacing: '0.2px',
    lineHeight: '18px',
    color: prediction_model_results_viz_1.VizColors.black,
    textAlign: 'center',
    padding: '16px 20%',
});
// ROC Chart
exports.ChartContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('chartContainer'), {
    padding: '16px',
});
exports.RocChartSummary = (0, StyleHelper_1.cssClass)(getModelResultClassName('rocChartSummary'), {
    padding: '16px',
});
// Overview section
exports.OverviewContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('overviewContainer'), {
    marginTop: '12px',
});
exports.OverviewScoreContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('overviewScoreContainer'), {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});
exports.OverviewScore = (0, StyleHelper_1.cssClass)(getModelResultClassName('overviewScore'), {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '64px',
    lineHeight: '72px',
    padding: '48px 48px 0 48px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
});
exports.OverviewScoreDescription = (0, StyleHelper_1.cssClass)(getModelResultClassName('overviewScoreDescription'), {
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '24px',
    lineHeight: '36px',
    padding: '32px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
    textAlign: 'center',
});
exports.OverviewScoreChart = (0, StyleHelper_1.cssClass)(getModelResultClassName('overviewScoreChart'), {
    padding: '12px 32px',
});
exports.OverviewDataDistribution = (0, StyleHelper_1.cssClass)(getModelResultClassName('overviewDataDistribution'), {
    padding: '32px',
});
// Additional performance metrics
var CommonPerformanceMetricsRow = {
    display: 'flex',
    maxWidth: '1450px',
};
exports.RegressionPerformanceMetricsRow = (0, StyleHelper_1.cssClass)(getModelResultClassName('RegressionPerformanceMetricsRow'), __assign(__assign({}, CommonPerformanceMetricsRow), { padding: '24px', flexWrap: 'wrap' }));
exports.BinomialPerformanceMetricsRow = (0, StyleHelper_1.cssClass)(getModelResultClassName('binomialPerformanceMetricsRow'), __assign(__assign({}, CommonPerformanceMetricsRow), { flexWrap: 'wrap' }));
exports.BinomialPerformanceMetricsRowCell = (0, StyleHelper_1.cssClass)(getModelResultClassName('performanceMetricsRowCell'), {
    padding: '12px',
});
exports.BinomialKeyMetricsFirstRow = (0, StyleHelper_1.cssClass)(getModelResultClassName('binomialKeyMetricsFirstRow'), {
    borderBottom: '1px solid ' + prediction_model_results_viz_1.VizColors.tableauGray06,
});
// Prediction Examination
var DataGridTextCommon = {
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0.2px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
};
exports.DataGridContainer = (0, StyleHelper_1.cssClass)(getModelResultClassName('dataGridContainer'), {
    marginTop: '16px',
    height: '800px',
    width: '100%',
    $nest: {
        '& div[role=gridcell]': __assign(__assign({ fontWeight: 350 }, DataGridTextCommon), { padding: '5px 12px', height: '28px' }),
    },
});
exports.DataGridPredictedValueSuccess = (0, StyleHelper_1.cssClass)(getModelResultClassName('dataGridHeaderText'), {
    color: prediction_model_results_viz_1.VizColors.successGlobal,
});
exports.DataGridPredictedValueFailure = (0, StyleHelper_1.cssClass)(getModelResultClassName('dataGridHeaderText'), {
    color: prediction_model_results_viz_1.VizColors.textError,
});
exports.DataGridHeader = (0, StyleHelper_1.cssClass)(getModelResultClassName('dataGridHeader'), {
    height: '30px',
    backgroundColor: dataGridHeaderBg,
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    color: prediction_model_results_viz_1.VizColors.tableauGray11,
});
exports.DataGridHeaderText = (0, StyleHelper_1.cssClass)(getModelResultClassName('dataGridHeaderText'), __assign({ textTransform: 'uppercase', fontWeight: 500 }, DataGridTextCommon));
exports.DataGridHeaderTextSortable = (0, StyleHelper_1.cssClass)(getModelResultClassName('dataGridHeaderTextSortable'), {
    $nest: {
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
});
exports.PredictionDetailContainerStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('predictionDetailContainerStyle'), __assign({ display: 'flex', flexDirection: 'column', padding: '16px 16px 51px 16px' }, DataGridTextCommon));
exports.PredictionDetailMetadataStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('predictionDetailMetadataStyle'), {
    paddingBottom: '16px',
});
exports.PredictionDetailHeaderStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('predictionDetailHeaderStyle'), {
    marginTop: '16px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '27px',
    fontStyle: 'normal',
});
exports.PredictionDetailValueStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('predictionDetailValueStyle'), {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
});
exports.PredictionDetailTopFactorStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('predictionDetailTopFactorStyle'), __assign({ fontWeight: 400 }, DataGridTextCommon));
// Examine model
exports.ModelCoefficientsMetadata = (0, StyleHelper_1.cssClass)(getModelResultClassName('modelCoefficientsMetadata'), {
    display: 'flex',
    padding: '12px',
});
exports.ModelCoefficientsDownloadButton = (0, StyleHelper_1.cssClass)(getModelResultClassName('modelCoefficientsDownloadButton'), {
    display: 'flex',
    gap: '6px',
});
exports.ModelCoefficientsEmptyChildStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('modelCoefficientsEmptyChildStyle'), {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
});
// Accuracy analyses
exports.ModelEvaluationListStyle = (0, StyleHelper_1.cssClass)(getModelResultClassName('modelEvaluationListStyle'), {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 0,
});
// Change Salesforce credentials
exports.modelResultsChangeSalesforceCredsInfoTextStyle = (0, StyleHelper_1.cssClass)('change-sf-user-info', {
    fontFamily: 'BentonSans Book',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '15px',
    textAlign: 'center',
    color: prediction_model_results_viz_1.VizColors.tableauGray10,
    width: '500px',
    marginTop: '20px',
});
//# sourceMappingURL=ModelResultStyles.js.map